<div class="w-full">
  <div class="glass-card p-6 rounded-2xl">
    <h1 class="text-2xl font-semibold text-text-primary">DMS-Export</h1>
    <p class="text-sm text-text-muted mb-4">
      Exportiert alle gelieferten Lieferzettel sowie die Dokumente abgeschlossener Auftragsbegleitscheine als PDF + .JPL ins DMS.
    </p>

    <div class="border-t border-white/10 pt-6">
      <button type="button" class="btn-primary flex items-center gap-2" [disabled]="isSyncing" (click)="triggerDmsSync()">
        <span class="material-icons text-xl">sync</span>
        @if (isSyncing) {
          Synchronisierung läuft...
        } @else {
          Mit DMS synchronisieren
        }
      </button>
    </div>
  </div>
</div>
